import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home.component';
import { sessionResolver } from '../../resolvers/session.resolver';

const seoData = {
  title: 'Finance Razor: Shave Down debt, Trim Expenses, Grow Wealth | financarazor.com',
  metaTags: [
    { name: 'description', content: 'Finance Razor helps you shave away financial confusion. Get a close shave on expenses, trim your debt, and groom your investments for a smoother financial future.' },
    { property: 'og:title', content: 'Finance Razor: Shave Down debt, Trim Expenses, Grow Wealth | financarazor.com' },
    { property: 'og:description', content: 'Finance Razor helps you shave away financial confusion. Get a close shave on expenses, trim your debt, and groom your investments for a smoother financial future.' },
    { property: 'og:url', content: 'content="https://app.financerazor.com"' }
  ]
};

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    data: { seo: seoData }    
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HomeRoutingModule { }
